import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const SortIcon = styled.div`
  /* display: inline-block; */
  font-size: 10px;
  position: absolute;
  padding-top: 3px;
  padding-left: 3px;
  top: -14px;
`;

const PositionWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: 0;
  width: 0;
  /* right: 10%; */
`;

const SortDirection = ({ sortDirection, sortedColumn, columnName }) => {
  if (columnName !== sortedColumn || sortDirection === 'off') {
    return null;
  }

  if (sortDirection === 'asc') {
    return (
      <PositionWrapper>
        <SortIcon>▲</SortIcon>
      </PositionWrapper>
    );
  }

  return (
    <PositionWrapper>
      <SortIcon>▼</SortIcon>
    </PositionWrapper>
  );
};

SortDirection.propTypes = {
  sortDirection: PropTypes.string.isRequired,
  sortedColumn: PropTypes.string,
  columnName: PropTypes.string.isRequired,
};

SortDirection.defaultProps = {
  sortedColumn: null,
};

export default SortDirection;
